import h from 'react-hyperscript';
import './Cards.scss';

const BasicCard = (props) => {
  const attributes = {
    id: null,
    className: 'card',
  };

  if (props.id) {
    attributes.id = props.id;
  }

  if (props.className) {
    attributes.className = attributes.className.concat(` ${props.className}`);
  }

  if (props.type) {
    attributes.className = attributes.className.concat(` card--${props.type}`);
  }

  return (
    h('div', attributes, props.children)
  );
};

export default BasicCard;
